import { render, staticRenderFns } from "./EditCategory.vue?vue&type=template&id=7f140cb7&"
import script from "./EditCategory.vue?vue&type=script&lang=ts&"
export * from "./EditCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports